<div *ngIf="haveAccess == false" class="main-container lg-view">
	<h3 *ngIf="siteNote?.siteNoteId">Complete Note</h3>
	<h5 *ngIf="siteNote">{{siteNote.siteName}}</h5>
	<div class="error">
		<p>You cannot complete this site note using the provided credentials</p>
	</div>
</div>
<div *ngIf="haveAccess && siteNote" class="main-container lg-view">
	<div class="modal-overlay" [class.overlay]="isLoading"></div>
	<app-loader *ngIf="isLoading"></app-loader>
	<h3>Complete Note</h3>
	<h5>77 Wall Street Manhattan</h5>

	<site-note-add-template #siteNoteAdd
		[siteNote]="siteNote"
		[isOnCompleteNote]="true"
	></site-note-add-template>

	<div class="smart-sync-link" *ngIf="siteNote?.photosSmartSyncUrl">
		<span>Photos:</span>
		<div>
			<mat-icon class="svg-icon" [svgIcon]="'Smart_Sync_Link'"></mat-icon>
			<a [href]="siteNote?.photosSmartSyncUrl">SmartSync</a>
		</div>
	</div>
	<hr>
	<div class="complete-form">
		<form class="main-form" [formGroup]="completeNoteForm">
			<div class="container">
				<mat-checkbox formControlName="isComplete">Complete</mat-checkbox>
			</div>
		
			<mat-form-field class="container column">
				<mat-label>Comment</mat-label>
				<textarea rows="10" matInput formControlName="comment"></textarea>
			</mat-form-field>
		</form>
	</div>
</div>

<div *ngIf="haveAccess" class="actions-container md-view">
	<ng-container>
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [clickAction]="onBackClick.bind(self)" [disabled]="isLoading"></action-button>

		<action-button [icon]="ButtonIcons.Save" [name]="'Save'" [clickAction]="onSaveClick.bind(self)" [disabled]="completeNoteForm.invalid || isLoading"></action-button>
	</ng-container>
</div>
